import React, { useState, useEffect } from 'react'
import { showToast } from './PopupMessage.jsx';
import api from '../Api.js';
import "../Styles/Upcoming_tour_content.css"
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Rajasthan from "../Images/rajasthan_pic.png"
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

function Upcoming_tour_content() {
    const navigate = useNavigate();
    const [bookedHotels, setBookedHotels] = React.useState([]);
    const customer = JSON.parse(localStorage.getItem('customer')) || {};
    const token = localStorage.getItem('accessToken') || '';
    console.log('Customer from localStorage:', customer);

    useEffect(() => {
        const fetchBookedHotels = async () => {
            try {
                // Replace with your API endpoint
                const response = await api.get(`/bookings/user/${customer?.id}`, {

                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // Include the token in the Authorization header
                    }
                });

                console.log('Booked Hotels:', response.data);
                if (response.data.status === true) {
                    setBookedHotels(response.data?.data || []);
                    showToast('Fetched Pending hotels successfully!', 'success');
                }
            } catch (error) {
                console.error('Error fetching booked hotels:', error);
            }
        }

        fetchBookedHotels();

    }, [])

    const bookedhotel = bookedHotels.filter(booking => booking.status === 'pending');
    console.log('Pending Booked Hotels:', bookedhotel);

    const [page, setPage] = useState(1);

    const itemsPerPage = 3;
    const totalPages = Math.ceil(bookedhotel.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = bookedhotel.slice(startIndex, endIndex);


    return (
        <div className="upcoming_tour_content">
            {bookedhotel.length === 0 ? (
                <p>No pending bookings available.</p>
            ) : <>


                {
                    currentItems.map((booking) => (
                        <div class="tripCard_wrapper">
                            <div class="tripCard_image">
                                <img src={`https://admin.jayrajgroup.org/uploads/hotels/${booking?.room?.hotel?.featured_image}`} alt="Rajasthan Tour" />
                            </div>
                            <div class="tripCard_content">
                                <h2 class="tripCard_title">{booking?.room?.hotel?.name}</h2>
                                <p class="tripCard_date" style={{ margin: "0px", fontWeight: "500" }}>{booking?.room?.hotel?.location}</p>
                                <p class="tripCard_date" style={{ margin: "0px", fontWeight: "500" }}>{booking?.room?.name}</p>
                                <p class="tripCard_date" style={{ margin: "0px", fontWeight: "700" }}>Total: ₹{booking?.total_price}/-</p>
                                <p class="tripCard_date" style={{ fontWeight: "700" }}>{dayjs(booking?.check_in).format("YYYY-MM-DD HH:mm:ss A")
                                } - {dayjs(booking?.check_out).format("YYYY-MM-DD HH:mm:ss A")
                                    }</p>
                                <div class="tripCard_buttons">
                                    <button class="tripCard_btnDetails" onClick={()=>navigate(`/hotel/reviewbooking/${booking?.id}`,{ state: { bookingDetails: booking,hotel:booking?.room?.hotel,Time:{bookingData:{hotel_id:booking.hotel_id,room_id:booking.room_id,check_in:booking.check_in,check_out:booking.check_out,adults:booking.adults,infants:booking.infants,children:booking.children} }} })}>Start Booking</button>
                                    <button class="tripCard_btnCancel">Cancel</button>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {currentItems.length > 0 && (
                    <div className="tourPaginationBar">
                        <Stack spacing={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                color="primary"
                            />
                        </Stack>
                    </div>
                )}




            </>}
        </div>


    )
}

export default Upcoming_tour_content